<template lang="pug">
.group-timetable-area
  .group-timetable-title.title-style 團班課程
  .group-timetable-main
    //- 上午時段
    TimeableItem.morning(
      time="morning",
      v-if="use_morning",
      :course_list="morningCourseList",
      @showhideCourseOut="showhideCourse",
      @clickCourseOut="clickCourse",
      @clickOptionOut="clickOption"
    )

    //- 下午時段
    TimeableItem.afternoon(
      time="afternoon",
      v-if="use_afternoon",
      :course_list="afternoonCourseList",
      @showhideCourseOut="showhideCourse",
      @clickCourseOut="clickCourse",
      @clickOptionOut="clickOption"
    )

    //- 晚上時段
    TimeableItem.night(
      time="night",
      v-if="use_night",
      :course_list="nightCourseList",
      @showhideCourseOut="showhideCourse",
      @clickCourseOut="clickCourse",
      @clickOptionOut="clickOption"
    )
</template>
<script>
import TimeableItem from './group-timetable-item'
export default {
  name: 'groupTimeTableArea',
  props: [
    'coursetable_data',
    'language_filter',
    'class_filter',
    'date_filter',
  ],
  data () {
    return {
      // 上午課程列表
      morningCourseList: {},
      use_morning: false,
      // 下午課程列表
      afternoonCourseList: {},
      use_afternoon: false,
      // 晚上課程列表
      nightCourseList: {},
      use_night: false,
      // 處理需要操作的課程ID
      course_id: false,
      process_course: false,
    }
  },
  components: {
    TimeableItem
  },
  watch: {
    // 當語言選項變更時
    language_filter () {
      this.getCourseList(this.language_filter, this.class_filter, this.date_filter)
    },
    // 當班別選項變更時
    class_filter () {
      this.getCourseList(this.language_filter, this.class_filter, this.date_filter)
    },
    // 當日期選項變更時
    date_filter () {
      this.getCourseList(this.language_filter, this.class_filter, this.date_filter)
    },
    // 監聽 Socket 是否有資訊
    '$root.socketProcess' (_status) {
      // 進行相關作業...
      if (_status) {
        this.$root.socketProcess = false
        // 獲取需要處理的訊息
        let message = this.$root.socketData
        // 處理完成之後
        this.$root.socketData = false
        // 開始進行處理
        if (message.process === 'course_join') {
          var vm = this
          // 尋找對應的課程資料
          for (const [_startTime, _courses] of Object.entries(this.morningCourseList)) {
            _courses.forEach(function (_course, _index) {
              if (_course.course_id == message.course_id) {
                // 強制更新人數
                vm.morningCourseList[_startTime][_index].course_student_use = message.use_count
              }
            })
          }
          for (const [_startTime, _courses] of Object.entries(this.afternoonCourseList)) {
            _courses.forEach(function (_course, _index) {
              if (_course.course_id == message.course_id) {
                // 強制更新人數
                vm.afternoonCourseList[_startTime][_index].course_student_use = message.use_count
              }
            })
          }
          for (const [_startTime, _courses] of Object.entries(this.nightCourseList)) {
            _courses.forEach(function (_course, _index) {
              if (_course.course_id == message.course_id) {
                // 強制更新人數
                vm.nightCourseList[_startTime][_index].course_student_use = message.use_count
              }
            })
          }
        }
      }
    }
  },
  created () {
    var vm = this
    setTimeout(() => { vm.$root.closeLoading() }, 250);
  },
  methods: {
    // 重新拉取課程列表
    async getCourseList (_langID, _courseType, _courseDate) {
      console.log('--> 預備請求獲取[語言:' + _langID + '][類型:' + _courseType + '][日期: ' + _courseDate + ']課程資料...')
      // 開啟載入中
      this.$root.useLoading()
      // 獲得課程清單
      await this.$root.apis.getGroupCourseList(_langID, _courseType, _courseDate, this.processCousreListSuccess, this.processCousreListError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 拉回課程列表成功
    processCousreListSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processCousreListError(_response)
      }

      // 處理課程清單
      let courseList = _response.body.data
      console.log('--> 獲得的課程資料: ', courseList)

      // 分類課表
      let morningCourseList = {}
      let afternoonCourseList = {}
      let nightCourseList = {}
      let use_morning = false
      let use_afternoon = false
      let use_night = false
      this.use_morning = false
      this.use_afternoon = false
      this.use_night = false
      courseList.forEach(function (_courseItem) {

        // 課程展開開關
        _courseItem.click_status = false

        // 上午時段課程清單
        if (_courseItem.start_hour <= 12) {
          use_morning = true
          if (morningCourseList[_courseItem.start_time]) {
            morningCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            morningCourseList[_courseItem.start_time] = []
            morningCourseList[_courseItem.start_time].push(_courseItem)
          }
        }

        // 下午時段課程清單
        else if (_courseItem.start_hour <= 17) {
          use_afternoon = true
          if (afternoonCourseList[_courseItem.start_time]) {
            afternoonCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            afternoonCourseList[_courseItem.start_time] = []
            afternoonCourseList[_courseItem.start_time].push(_courseItem)
          }
        }

        // 晚上時段課程清單
        else {
          use_night = true
          if (nightCourseList[_courseItem.start_time]) {
            nightCourseList[_courseItem.start_time].push(_courseItem)
          } else {
            nightCourseList[_courseItem.start_time] = []
            nightCourseList[_courseItem.start_time].push(_courseItem)
          }
        }
      })

      // 更新資料
      this.morningCourseList = morningCourseList
      this.afternoonCourseList = afternoonCourseList
      this.nightCourseList = nightCourseList
      this.use_morning = use_morning
      this.use_afternoon = use_afternoon
      this.use_night = use_night
      console.log('--> 課程資料獲取完成...');
    },
    // 拉回課程列表失敗
    processCousreListError () {

    },
    // 開關課程資訊
    showhideCourse (_time, _start_time, _index_in) {
      console.log('選定時區: ', _time)
      console.log('選定時間: ', _start_time)
      console.log('選定個數: ', _index_in)
      if (_time === 'morning') {
        this.morningCourseList[_start_time][_index_in].click_status = !this.morningCourseList[_start_time][_index_in].click_status
      }
      if (_time === 'afternoon') {
        this.afternoonCourseList[_start_time][_index_in].click_status = !this.afternoonCourseList[_start_time][_index_in].click_status
      }
      if (_time === 'night') {
        this.nightCourseList[_start_time][_index_in].click_status = !this.nightCourseList[_start_time][_index_in].click_status
      }
      setTimeout(() => { this.$forceUpdate() }, 100);
    },
    // 選取課程資料
    clickCourse (_courseID) {
      console.log('--> 用戶點選課程...');
      this.$root.enterCourse(_courseID)
    },
    // 當用戶點擊課程按鈕
    clickOption (_course, _type) {
      console.log(_course)
      // 紀錄目前操作的課程ID
      this.course_id = _course.course_id
      this.process_course = _course
      // 請求互動課程
      if (_type === 'inter') {

        // 未開放互動課程
        if (!_course.have_inter) {
          this.$root.openOptionView({
            title: "未開放互動的課程",
            text_1: "這堂課程目前不開放互動教室",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 是否已經購買過課程
        if (_course.order_meeting) {
          this.registerCourse()
          return
        }

        // 人數已滿
        if (_course.course_student_use >= _course.course_student_max) {
          this.$root.openOptionView({
            title: "目前人數額滿",
            text_1: "您選擇的課程目前額滿",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 處理登記課程
        this.$root.openOptionView({
          title: "互動課程",
          text_1: "您選擇互動課程",
          text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_point, 0) + ' 點數，確認進入教室？',
          course_text: _course.title,
          option_1: "確認",
          option_2: "我再考慮",
          option_1_fun: this.registerCourse,
          option_2_fun: false
        })
        return
      }

      // 請求直播課程
      else if (_type === 'live') {

        // 未開放直播課程
        if (!_course.have_live) {
          this.$root.openOptionView({
            title: "未開放直播的課程",
            text_1: "這堂課程目前不開放直播教室",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 是否已經購買過課程
        if (_course.order_live) {
          this.openCourseLive()
          return
        }

        // 處理登記直播
        this.$root.openOptionView({
          title: "直播課程",
          text_1: "您選擇直播課程",
          text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_live_point, 0) + ' 點數，確認進入直播？',
          course_text: _course.title,
          option_1: "確認",
          option_2: "我再考慮",
          option_1_fun: this.openCourseLive,
          option_2_fun: false
        })
        return
      }

      // 發生未知的問題
      else {
        this.$root.openOptionView({
          title: "發生未知的問題",
          text_1: "很抱歉，目前功能發生障礙",
          text_2: '請稍後再試',
          course_text: '',
          option_1: "瞭解",
          option_2: "",
          option_1_fun: false,
          option_2_fun: false
        })
        return
      }
    },
    // 請求預約團體班課程
    async registerCourse () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求預約課程
      await this.$root.apis.registerGroupCourse(this.course_id, this.processRegCourseSuccess, this.processRegCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回預約成功的資料
    processRegCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 更新課程資料
      this.getCourseList(this.language_filter, this.class_filter, this.date_filter)

      // 進入會議室
      if (this.process_course.is_started) {
        this.$root.common.goMeet(0, this.course_id)
      }

      // 告知學員已經預約成功
      else {
        this.$root.openOptionView({
          title: "預約成功",
          text_1: '課程已經預約成功',
          text_2: '請在課程開始時進入會議室哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
    },
    // 處理返回預約失敗的資料
    processRegCourseError (_error) {
      this.$root.openOptionView({
        title: "扣點失敗",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    },
    // 請求進入課程直播
    async openCourseLive () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求進入課程直播
      await this.$root.apis.liveGroupCourse(this.course_id, this.processLiveCourseSuccess, this.processLiveCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回直播請求成功的資料
    processLiveCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 更新課程資料
      this.getCourseList(this.language_filter, this.class_filter, this.date_filter)

      // 進入直播間
      this.$root.common.goLive(this.course_id)
    },
    // 處理返回直播請求失敗的資料
    processLiveCourseError (_error) {
      this.$root.openOptionView({
        title: "發生問題",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    }
  }
}
</script>
<style lang="sass" scoped>
</style>
